import { createMigration } from './utils';

export const migrationTo9_197 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            map.get('children', []).forEach((asset, c) => {
                const isColorEditable = !!((
                    asset.get('classType') === 'GraphicStyleTextAsset' ||
                    asset.get('classType') === 'IconAsset'
                ));
                map.setIn(['children', c, 'isColorEditable'], isColorEditable);
            });
        });
    },
});
